const SubnaticaBelowZeroPage = () => {
  return (
    <div>SubnaticaBelowZeroPage</div>
  )
}

export default SubnaticaBelowZeroPage